import { isRichTextMarkup, plainTextToRichParagraphs, richTextToPlain } from '@/shared/lib';

/**
 * Комментарий в разметке редактора: простой текст — комментарий системы или сохранённый до того,
 * как его стали оформлять, — переводится построчно в абзацы, разметка остаётся как есть.
 *
 * Редактор разметки схлопнул бы переносы простого текста в пробел, а знаки разметки в нём приняты
 * за теги; абзацы, а не переносы, — потому что за комментарием в поле идут замечания.
 */
export const toEditorComment = (comment: string): string =>
  comment === '' || isRichTextMarkup(comment) ? comment : plainTextToRichParagraphs(comment);

/** Разметка без текста: пустое поле или, например, пустой пункт списка. */
export const isBlankRichText = (html: string): boolean => richTextToPlain(html).trim() === '';

/**
 * Текст вкладки правки текста: действующий комментарий и за ним замечания, каждое отдельным абзацем.
 * Сохранённая правка становится комментарием целиком — замечания, оставленные в поле, входят в её
 * текст. У правила без комментария в поле остаются одни замечания.
 */
export const joinCommentRemarks = (comment: string, remarks: readonly string[]): string =>
  [comment, ...remarks].map(toEditorComment).join('');
